export const dateTimeFormat = 'DD.MM.YYYY HH:mm';
export const locale = 'pl';
export const errorMessage = 'Oooops, someting has gone wrong. Try again!';
